<template>
    <div class="automation-prefilters" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div class="toolbar-header">
            <h3>{{ $t("automation.executionRules") }}</h3>
            <SupsisButton ghost icon="close" @click="$emit('close')" />
        </div>

        <div class="toolbar-body">
            <div class="info-box">
                <i class="material-icons">info</i>
                <span>{{ $t("automation.preFilterInfo") }}</span>
            </div>

            <PreFilterConfig v-model="preFilters" :automation="automation" />

            <div class="toolbar-actions">
                <SupsisButton @click="$emit('close')">{{ $t("message.cancelText") }}</SupsisButton>
                <SupsisButton primary @click="save">{{ $t("message.save") }}</SupsisButton>
            </div>
        </div>
    </div>
</template>

<script>
import PreFilterConfig from '../../../components/PreFilterConfig.vue';
import SupsisButton from '../../../../Settings/components/SupsisButton.vue';
import { AUTOMATION_API } from '../../../../../../api/automation';
import _ from 'lodash';

export default {
    name: 'AutomationPreFilters',
    components: {
        PreFilterConfig,
        SupsisButton,
    },
    props: {
        automation: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            preFilters: _.cloneDeep(_.get(this.automation, 'preFilters', {
                enabled: false,
                operator: 'and',
                groups: [],
            })),
        };
    },
    methods: {
        async save() {
            try {
                await AUTOMATION_API.updateAutomationSingleKey(
                    this.automation._id,
                    'preFilters',
                    this.preFilters
                );

                this.$message.success(this.$t('automation.preFiltersSaved'));
                this.$emit('updateAutomation', {
                    ...this.automation,
                    preFilters: this.preFilters,
                });
                this.$emit('close');
            } catch (error) {
                console.error('Error saving preFilters:', error);
                this.$message.error(this.$t('automation.preFiltersSaveError'));
            }
        },
    },
};
</script>

<style scoped lang="scss">
.automation-prefilters {
    position: absolute;
    right: 20px;
    top: 70px;
    width: 900px;
    max-width: calc(100vw - 100px);
    max-height: calc(100vh - 100px);
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    z-index: 1000;

    .toolbar-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px;
        border-bottom: 1px solid #e8e8e8;

        h3 {
            margin: 0;
            font-size: 18px;
            font-weight: 600;
        }
    }

    .toolbar-body {
        flex: 1;
        overflow-y: auto;
        padding: 20px;

        .info-box {
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 12px;
            background: #e6f7ff;
            border-radius: 6px;
            margin-bottom: 20px;
            color: #1890ff;
            font-size: 14px;

            .material-icons {
                font-size: 20px;
            }
        }

        .toolbar-actions {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 20px;
            padding-top: 20px;
            border-top: 1px solid #e8e8e8;
        }
    }
}
</style>

